import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import RegistroNeuroterapeuta from './components/RegistroNeuroterapeuta';
import LoginScreen from './LoginScreen';
import TenantsScreen from './TenantsScreen';
import TratamientosScreen from './TratamientosScreen';
import NeuroterapeutasScreen from './components/NeuroterapeutasScreen';
import NeuroDashboard from './components/NeuroDashboard';
import RecuperarPassword from './components/RecuperarPassword'; // Debes crear este componente
import RestablecerPassword from './components/RestablecerPassword';


function AppRoutes() {
  const [token, setToken] = useState(localStorage.getItem('token') || null);
  const [tenant, setTenant] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!token) { setUser(null); return; }
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      setUser(payload);
    } catch {
      setUser(null);
    }
  }, [token]);

  // Rutas públicas y protegidas
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/registro-neuroterapeuta" element={<RegistroNeuroterapeuta tenant_id={tenant ? tenant.id : 1} />} />
      <Route path="/login" element={<LoginScreen onLogin={tk => { localStorage.setItem('token', tk); setToken(tk); }} />} />
      <Route path="/recuperar-password" element={<RecuperarPassword />} />
      <Route path="/reset-password" element={<RestablecerPassword />} />
      <Route path="/braineka-admin/reset-password" element={<RestablecerPassword />} />

      {/* Rutas protegidas por token y rol */}
      <Route path="/dashboard" element={
        token && user ? (
          user.role === 'superadmin' ? (
            !tenant ? (
              <div className="App">
                <h2>Bienvenido Superadmin</h2>
                <button onClick={() => { localStorage.removeItem('token'); setToken(null); window.location.href = '/'; }}>Cerrar sesión</button>
                <TenantsScreen token={token} onSelectTenant={setTenant} />
              </div>
            ) : (
              <div className="App">
                <h2>Tenant: {tenant.nombre}</h2>
                <button onClick={() => setTenant(null)}>Cambiar tenant</button>
                <button onClick={() => { localStorage.removeItem('token'); setToken(null); window.location.href = '/'; }}>Cerrar sesión</button>
                <TratamientosScreen token={token} tenant={tenant} />
                <NeuroterapeutasScreen token={token} tenant={tenant} />
              </div>
            )
          ) : user.role === 'psicologo' ? (
            <NeuroDashboard token={token} user={user} onLogout={() => { localStorage.removeItem('token'); setToken(null); window.location.href = '/'; }} />
          ) : (
            <div className="App"><h2>Acceso no autorizado</h2></div>
          )
        ) : (
          <div className="App"><h2>Acceso no autorizado</h2></div>
        )
      } />

      {/* Fallback: solo muestra error si no es pública ni dashboard */}
      <Route path="*" element={<LandingPage />} />
    </Routes>
  );
}

export default function App() {
  const publicUrl = process.env.PUBLIC_URL || '';
  let basename = '/';

  if (publicUrl) {
    try {
      basename = new URL(publicUrl, window.location.origin).pathname || '/';
    } catch {
      basename = publicUrl.startsWith('/') ? publicUrl : '/';
    }
  }

  return (
    <Router basename={basename}>
      <AppRoutes />
    </Router>
  );
}
